import { render, staticRenderFns } from "./coursePage.vue?vue&type=template&id=748d62e6&scoped=true&"
import script from "./coursePage.vue?vue&type=script&lang=ts&"
export * from "./coursePage.vue?vue&type=script&lang=ts&"
import style0 from "./coursePage.vue?vue&type=style&index=0&id=748d62e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d62e6",
  null
  
)

export default component.exports